import styled from '@emotion/styled';
import { useState } from 'react';

import { Stack } from '@/components/ui/Stack';
import { Heading } from '@/components/ui/Text';
import { DialogDrawer } from '@/components/ui/dialog-drawer';
import { colors, font } from '@/lib/theme';
import { useI18n } from '@/locales';

import { Expandable } from './Expandable';

const Prose = styled.div`
	${font('IR100', '160%')}
	color: ${colors.typography.body};
	white-space: pre-line;
	overflow-wrap: anywhere;
`;

interface DescriptionProps {
	text: string;
}

/** The host's description of the place; when long, "Show more" opens it in full. */
export const Description = ({ text }: DescriptionProps) => {
	const t = useI18n();
	const [open, setOpen] = useState(false);
	return (
		<Stack gap="space30">
			<Heading as="h2" size="md">
				{t('property.about.title')}
			</Heading>
			<Expandable collapsedHeight={192} onShowMore={() => setOpen(true)}>
				<Prose>{text.trim()}</Prose>
			</Expandable>
			<DialogDrawer
				open={open}
				onOpenChange={setOpen}
				title={t('property.about.title')}
				closeLabel={t('common.close')}
				desktopWidth="680px"
				mobileFill="full"
			>
				<Prose>{text.trim()}</Prose>
			</DialogDrawer>
		</Stack>
	);
};
